import { useContext, useEffect, useLayoutEffect } from 'react'
import { useParams } from 'react-router-dom'
import { isMobile } from 'react-device-detect'
import { useMediaQuery } from '@mui/material'
import useSWR from 'swr'

import { normalizePresentation } from '../_types'
import { PresentationContext, NetworkContext, AppLoading } from '../providers'
import { Presentation, PresentationMobile } from '../components'

const {
  REACT_APP_BASE_API
} = process.env

let baseAPIs:object = REACT_APP_BASE_API ? JSON.parse(REACT_APP_BASE_API) : {};

export const PresentationContainer: React.FC = () => {
  const isLandscape = useMediaQuery('(orientation: landscape)')
  const { presentationId, sourceSite } = useParams()

  const { networkFetcher } = useContext(NetworkContext)
  const { activeSlideIndex, presentationSettings, setPresentationSettings } =
    useContext(PresentationContext)

  useLayoutEffect(() => {
    if (presentationSettings?.networkReturned)
      document.body.style.backgroundColor = 'rgb(88 88 90)'
  }, [presentationSettings?.networkReturned])

  // @ts-ignore
  const presentationURL = sourceSite ? baseAPIs[sourceSite] : "";
  const { data: presentationData, error: presentationDataError } = useSWR(
    `${presentationURL}/${presentationId}`,
    networkFetcher({
      normalizer: normalizePresentation,
      site: sourceSite
    }),
    {
      dedupingInterval: 600000,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    }
  )

  useEffect(() => {
    setPresentationSettings((staleSettings: any) => {
      return {
        ...staleSettings,
        slides: presentationData?.slides,
        pdfURL: presentationData?.pdfURL,
        pptURL: presentationData?.pptURL,
        pptxURL: presentationData?.pptxURL,
        siteCode: sourceSite,
        networkReturned: Boolean(presentationData),
      }
    })
  }, [presentationData, setPresentationSettings, sourceSite])

  const handleOnSelectNext = () => {
    if (activeSlideIndex < presentationSettings?.slides?.length - 1) {
      setPresentationSettings((stale: any) => {
        return {
          ...stale,
          activeSlideIndex: stale.activeSlideIndex + 1,
        }
      })
    }
  }
  const handleOnSelectPrev = () => {
    if (activeSlideIndex > 0) {
      setPresentationSettings((stale: any) => {
        return {
          ...stale,
          activeSlideIndex: stale.activeSlideIndex - 1,
        }
      })
    }
  }
  const handleSlideSelect = (idx: number) => {
    setPresentationSettings((stale: any) => {
      return {
        ...stale,
        activeSlideIndex: idx,
      }
    })
  }

  if (presentationDataError) {
    return <>Error - {`${presentationDataError?.response?.data?.err}`}</>
  }
  if (!presentationSettings?.networkReturned) {
    return <AppLoading />
  }
  if (!presentationSettings?.slides?.length) {
    return <>no slides found</>
  }
  return isMobile && isLandscape ? (
    <PresentationMobile
      allowTouchMove={isMobile}
      slides={presentationSettings?.slides}
      pdfURL={presentationSettings?.pdfURL}
      pptURL={presentationSettings?.pptURL}
      pptxURL={presentationSettings?.pptxURL}
      activeIndex={activeSlideIndex}
      onSelectNext={handleOnSelectNext}
      onSelectPrev={handleOnSelectPrev}
      onSlideSelect={handleSlideSelect}
      isMobile={isMobile}
      isLandscape={isLandscape}
    />
  ) : (
    <Presentation
      allowTouchMove={isMobile}
      slides={presentationSettings?.slides}
      pdfURL={presentationSettings?.pdfURL}
      pptURL={presentationSettings?.pptURL}
      pptxURL={presentationSettings?.pptxURL}
      activeIndex={activeSlideIndex}
      onSelectNext={handleOnSelectNext}
      onSelectPrev={handleOnSelectPrev}
      onSlideSelect={handleSlideSelect}
      isMobile={isMobile}
      isLandscape={isLandscape}
    />
  )
}

export default PresentationContainer
